module.exports = __webpack_public_path__ + "img/logo.812568b0.svg";